import { memo } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import FilterResultsHeadline from "@vms/FilterResultsHeadline";
import HomeHeaderControls from "@pages/Home/components/HomeHeader/HomeHeaderControls";
import Divider from "@components/Divider";

const HomeHeader: FCX<{
    resultCount: number;
    isLoading?: boolean;
}> = ({
    resultCount,
    isLoading,
    children,
}) => {
    return (
        <>
            <div className="HomeHeader">
                <FilterResultsHeadline
                    resultCount={resultCount}
                    isLoading={isLoading}
                />
                <HomeHeaderControls>
                    {children}
                </HomeHeaderControls>
            </div>
            <Divider lineBg="linear-gradient(114deg, #EB0089 45.47%, #FF5AB9 79.71%)"/>
        </>
    )
}

export default memo(HomeHeader);